(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const menus = [...document.querySelectorAll('[data-ym-mega]')];
  const openDelay = 320;
  const closeDelay = 170;
  const closeTransition = 320;
  const syncOverlay = () => {
    document.documentElement.classList.toggle('ym-menu-open', desktop.matches && menus.some((menu) => menu.open));
  };

  const setupMegaMenu = (details) => {
    let openTimer;
    let closeTimer;
    let transitionTimer;

    const clearTimers = () => {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      window.clearTimeout(transitionTimer);
    };

    const open = () => {
      if (!desktop.matches) return;
      clearTimers();
      details.classList.remove('ym-mega--closing');
      if (details.open) return;

      openTimer = window.setTimeout(() => {
        menus.forEach((menu) => {
          if (menu !== details) {
            menu.classList.remove('ym-mega--closing');
            menu.open = false;
          }
        });
        details.open = true;
        syncOverlay();
      }, openDelay);
    };

    const close = () => {
      if (!desktop.matches) return;
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        if (!details.open) return;
        details.classList.add('ym-mega--closing');
        transitionTimer = window.setTimeout(() => {
          details.open = false;
          details.classList.remove('ym-mega--closing');
          syncOverlay();
        }, closeTransition);
      }, closeDelay);
    };

    details.addEventListener('pointerenter', open);
    details.addEventListener('pointerleave', close);
    details.addEventListener('toggle', () => {
      if (details.open) details.classList.remove('ym-mega--closing');
      syncOverlay();
    });
  };

  menus.forEach(setupMegaMenu);
  desktop.addEventListener('change', () => {
    if (!desktop.matches) menus.forEach((menu) => {
      menu.classList.remove('ym-mega--closing');
      menu.open = false;
    });
    syncOverlay();
  });
})();
